/**
 *
 * LinkList
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';

const styles = () => ({
  root: {
    paddingBottom: 4,
    paddingTop: 0,
  },
});

function LinkList({ name, clickHandler, link, classes }) {
  return (
    <ListItem
      button
      onClick={() => clickHandler(link)}
      className={classes.root}
    >
      <ListItemText primary={name} />
    </ListItem>
  );
}

LinkList.propTypes = {
  classes: PropTypes.object,
  name: PropTypes.string,
  clickHandler: PropTypes.func,
  link: PropTypes.string,
};

export default withStyles(styles)(LinkList);
